(() => {
  const header = document.querySelector('.ruem-header');
  if (header) {
    const btn = header.querySelector('[data-menu-toggle]');
    const nav = header.querySelector('[data-mobile-nav]');
    btn?.addEventListener('click', () => {
      const open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      nav?.classList.toggle('is-open', !open);
    });
  }

  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (e) => {
      const id = link.getAttribute('href');
      if (!id || id === '#') return;
      const el = document.querySelector(id);
      if (el) {
        e.preventDefault();
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  const faqButtons = document.querySelectorAll('.ruem-faq__question');
  faqButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const item = button.closest('.ruem-faq__item');
      item?.classList.toggle('is-open');
    });
  });
})();
